import { RequestStatus } from 'typed/api';
import { ActionType, Action } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { Entity, IEntityReducerState, isPaginationSlice, isNetworkArray, isSimpleArray, IEntityReducerCreator } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';

const entityAddReducer: IEntityReducerCreator = <E extends Entity, T extends ActionType>(def: IEntityReducerState<E>, type: T): IReducer<any, Action<T>> => {
    const nr = networkActionReducer<T, E>(type);
    return function entityAddReducer(state: IEntityReducerState<E> | undefined = deepClone(def), action: Action<T>): IEntityReducerState<E> {
        if (action.type === type) {
            let data = isNetworkArray(state) ? state.Data : isSimpleArray(state) ? state : [state];
            switch (action.payload.status) {
                case RequestStatus.UNSYNCED:
                    if (isPaginationSlice(state)) {
                        state = deepAssign(state, {
                            Count: state.Count + 1,
                            TotalCount: state.Count + 1,
                        })
                    }

                    data = deepAssign(data, [...data, action.payload.entity]);
                    break;

                case RequestStatus.PENDING:
                case RequestStatus.FAILED:
                    data = deepAssign(data, data.map(item => action.payload.entity.ID === item.ID ? nr(item, action) : item));
                    break;

                case RequestStatus.SUCCEEDED:
                    const response = action.payload.response;
                    data = deepAssign(data, data.map(item =>
                        action.payload.entity.ID === item.ID ?
                            nr({ ID: (response as unknown as number), Custom: { internalID: item.ID } } as E, action) :
                            item
                    ));
            }

            return isNetworkArray(state) ? deepAssign(state, { Data: data }) : isSimpleArray(state) ? data : data[0];
        }
        return state;
    };
}

export default entityAddReducer;